import type { TExtratorDeDatas } from '@/features/simulador/shared/domain/extratores-de-datas'

export function getDatasParcelas<T extends { dataSimulacao: string }>(
  grupos: T,
  extratores: Array<TExtratorDeDatas<T>>,
): string[] {
  const datas = extratores.flatMap((extrair) => extrair(grupos)).filter((v): v is string => v != null)
  return datas.length > 0 ? datas : [grupos.dataSimulacao]
}
